import { render, staticRenderFns } from "./registrationConsultationList.vue?vue&type=template&id=246d2a20&scoped=true"
import script from "./registrationConsultationList.vue?vue&type=script&lang=js"
export * from "./registrationConsultationList.vue?vue&type=script&lang=js"
import style0 from "./registrationConsultationList.vue?vue&type=style&index=0&id=246d2a20&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d2a20",
  null
  
)

export default component.exports